import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails, ICarrierAreaResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class CreateCarrierAreaCommand
    extends IRequestCommand<
    ICarrierAreaResponseDTO,
    ErrorDetails,
    ICreateCarrierAreaRequest
    > {
    override _commandType: CommandRequestType = CommandRequestType.POST;

    public override setParameters(parameters: ICreateCarrierAreaRequest) {
        this._commandBody = parameters;
        this.urlSections.push('carriers');
        this.urlSections.push(`${parameters.carrierId}`);
        this.urlSections.push('carrierArea');
        this.composeUrl();
    }
}

export interface ICreateCarrierAreaRequest extends ICommandParameters,ICarrierAreaResponseDTO  {
  carrierId: number;
}
